import request from '@/utils/request'

export function fetchList(data) {
  return request({
    url: '/CoachCommissionSchema/List',
    method: 'post',
    data,
  })
}

export function getItem(id) {
  return request({
    url: '/CoachCommissionSchema/Get',
    method: 'post',
    data: { id },
  })
}

export function createItem(data) {
  // console.log('createItem', data)

  return request({
    url: '/CoachCommissionSchema/Create',
    method: 'post',
    data,
  })
}

export function updateItem(data) {
  // console.log('updateItem', data)

  return request({
    url: '/CoachCommissionSchema/Update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/CoachCommissionSchema/Delete',
    method: 'delete',
    data,
  })
}

export function updateSchemas(data) {
  // console.log('UpdateSchemas', data)

  return request({
    url: '/CoachCommissionSchema/UpdateSchemas',
    method: 'post',
    data,
  })
}
